import { useIsEnterpriseUser } from '#pplx/frontend/auth/useIsEnterpriseUser.js';
import { useIsSubscribed } from '#pplx/frontend/auth/useIsSubscribed.js';
import { useIsUserLoggedIn } from '#pplx/frontend/auth/userHooks.js';
import * as BUILD_CAPABILITIES from '#pplx/frontend/deployment-capabilities/build.js';
import { useMemo } from 'react';
export const useShowUpgradeButton = () => {
    const { hasAccessToProFeatures } = useIsSubscribed();
    const isEnterpriseUser = useIsEnterpriseUser();
    const isUserLoggedIn = useIsUserLoggedIn();
    return useMemo(() => {
        return (BUILD_CAPABILITIES.payments && isUserLoggedIn && !isEnterpriseUser && !hasAccessToProFeatures);
    }, [isUserLoggedIn, isEnterpriseUser, hasAccessToProFeatures]);
};
//# sourceMappingURL=useShowUpgradeButton.js.map